import React, { useEffect, useState } from "react";
import { ListSubheader, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const SearchWithDebounce = ({ searchValue, setSearchValue }) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(searchValue);

  // Debounce эффект
  useEffect(() => {
    const timerId = setTimeout(() => {
      setSearchValue(inputValue);
    }, 300); // Задержка 300ms

    return () => {
      clearTimeout(timerId);
    };
  }, [inputValue, setSearchValue]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key !== "Escape") {
      e.stopPropagation();
    }
  };

  return (
    <ListSubheader
      sx={{
        zIndex: 5,
        paddingLeft: 0,
        paddingRight: 0,
      }}
    >
      <TextField
        fullWidth
        autoFocus
        placeholder={t("placeholders:search_select")}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </ListSubheader>
  );
};

SearchWithDebounce.muiSkipListHighlight = true;

export default SearchWithDebounce;
